/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CouponSummary {
  acquisition?: number;
  businessUnitId?: number;
  businessUnitName?: string;
  couponId?: number;
  couponType?: number;
  couponUsageType?: string;
  couponUsageTypeId?: number;
  dateCreated?: Date;
  dateExpired?: Date;
  dateUpdated?: Date;
  enabled?: boolean;
  freeShipping?: number;
  freebieCount?: number;
  freebieMessage?: string;
  glampoints?: number;
  influencerStatus?: string;
  influencerStatusTypeIdRestriction?: number;
  maxRedeems?: number;
  name?: string;
  products?: number;
  quantityUsed?: number;
  renewal?: number;
  subscriptionTypeIds?: string;
  subscriptionTypeNames?: string;
  upgrade?: number;
  value?: number;
  valueString?: string;
}
